<template>
  <main class="sa-signup-box sa-up-id-card">
    <div class="sa-card-large sa-profile">
    <div class="sa-mob-header sa-h-sm-up">
      <h5 class="sa-card-tit">Back</h5>
      <button class="sa-btn-back" @click="$router.go(-1)">
        <i class="icon-left-arrow"></i>
      </button>
      </div>
    </div>
    <div class="sa-upload-box-cont">
      <i class="sa-sprite sa-medical-card sa-h-sm-up"></i>
      <img src="../../assets/img/doctor-id.svg" alt="doctor id" class="sa-h-xs"/>
      <img src="https://img.litedev.com/images/static/logo.svg" alt="logo" class="sa-logo-abs sa-h-xs" />
      <div class="sa-i-c-cont">
        <h3>Medical Licence ID Card</h3>
        <p>Upload your medical card for the <span class="sa-d-block">registration process.</span></p>
        <file-upload v-on:file-upload-success="uploadedfile = $event"/>
        <!-- <input type="button" class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-mt30" value="Continue"
          @click="confirmUpload(uploadedfile)" /> -->
          <input type="button" class="sa-btn sa-btn-outline-primary sa-btn-large sa-h-xs" value="Go Back"
          @click="$parent.showUploadView = false" id="upload" name="upload" />
          <button type="button" class="sa-btn sa-btn-primary sa-btn-large sa-ml10 sa-blue-btn"
            @click="confirmUpload(uploadedfile)">Continue</button>
      </div>
    </div>
    <div class="sa-dialog sa-mob-w90" v-show="confirmUploadDial || confirmOtpDial" @click.stop>
      <div class="sa-dialog-body" @click.stop>
        <button class="sa-btn sa-close sa-close-line" @click="closeDialog"><i class="icon-cancel"></i></button>
        <form v-show="confirmUploadDial">
          <div class="sa-form-group sa-mob-pb20">
            <label class="sa-darkblue-text sa-mob-txt-cnt">Enter OTP</label>
            <div class="sa-row">
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input v-model="digit_1" ref="digit_1" type="text" maxlength="1" class="sa-form-control"
                  @input="focusInput('1')" name="digit_1" id="digit_1"/>
              </div>
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input v-model="digit_2" ref="digit_2" type="text" maxlength="1" class="sa-form-control"
                  @input="focusInput('2')" @keyup.delete="$refs.digit_1.focus()" name="digit_2" id="digit_2" />
              </div>
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input v-model="digit_3" ref="digit_3" type="text" maxlength="1" class="sa-form-control" name="digit_3" id="digit_3"
                  @input="focusInput('3')" @keyup.delete="$refs.digit_2.focus()" />
              </div>
              <div class="sa-col-xs3 sa-col-sm3 sa-col-md3 sa-col-lg3">
                <input v-model="digit_4" ref="digit_4" type="text" maxlength="1" class="sa-form-control" name="digit_4" id="digit_4"
                  @keyup.delete="$refs.digit_3.focus()" />
              </div>
              <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12 sa-mt10">
                <!-- <span class=" sa-val-err" v-if="showEnterOtp">Please enter OTP</span> -->
                <a @click="confirmUpload(uploadedfile)" class="sa-pull-right sa-cursor">Resend OTP ?</a>
                <!-- <a v-else class="sa-pull-right">Re-send again</a> -->
              </div>
            </div>
          </div>
          <button type="button" class="sa-btn sa-btn-primary sa-btn-large sa-btn-block sa-blue-btn" @click="confirmOtp">Confirm </button>
          <!-- <input type="button" v-model="otp" class="sa-btn sa-btn-primary sa-btn-large sa-btn-block" value="Confirm" @click="confirmOtp"  /> -->
        </form>
        <div class="sa-reg-pop sa-text-center sa-sprite" v-show="confirmOtpDial">
          <button class="sa-btn sa-close" @click="reg()"><i class="icon-cancel"></i></button>
          <p class="sa-black-text">Thank you for registering as a
            doctor/Health care provider with Sanar. We congratulate you on taking this first step towards widening your
            patient outreach. We are currently reviewing your application we will be in touch with you once your
            varification process is complete.</p>
          <span  class="sa-blue-text">Please check your email for login access.</span>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
  import FileUploadVue from '../../components/common/FileUpload.vue';
  export default {
    components: {
      'file-upload': FileUploadVue
    },
    data() {
      return {
        confirmUploadDial: false,
        confirmOtpDial: false,
        continueToUpload: false,
        loader: false,
        resendOtp: false,
        showEnterOtp: false,
        countDown: 45,
        digit_1: '',
        digit_2: '',
        digit_3: '',
        digit_4: '',
        otp: '',

        uploadedfile: null,
        fileList: [],
      }
    },
    methods: {
      submit() {
        const formData = new FormData();
        formData.append("file", fileList[0].blob);
        fetch
          .post(url, formData)
          .then(() => { })
          .catch(() => { });
      },
      closeDialog(type) {
        this.confirmUploadDial = false
        this.confirmOtpDial = false
        this.digit_1 = ''
        this.digit_2 = ''
        this.digit_3 = ''
        this.digit_4 = ''
      },
      confirmUpload(e) {
        let _self = this
        if(e) {
          _self.loader = true
          this.$emit('confirm-upload', {file: e})
        } else {
          this.$store.dispatch('SET_ALERTMESSAGE', {msg: 'Please upload the file', class: 'sa-a-danger'})
        }
        /* this.confirmUploadDial = true; */
      },
      confirmOtp() {
        this.loader = true
        if (!this.digit_1 || !this.digit_2 || !this.digit_3 || !this.digit_4) {
          this.$store.dispatch('SET_ALERTMESSAGE', {msg: 'Please enter otp', class: 'sa-a-danger'})
          //this.showEnterOtp = true
          return false
        }
        this.otp = this.digit_1 + this.digit_2 + this.digit_3 + this.digit_4
        //this.showEnterOtp = false
        this.$emit('confirm-upload', { otp: this.otp })
        /* this.confirmUploadDial = false;
        this.confirmOtpDial = true; */
      },
      countDownTimer() {
        if (this.countDown > 0) {
          setTimeout(() => {
            this.countDown -= 1
            this.countDownTimer()
          }, 1000)
        } else {
          this.resendOtp = false
          this.countDown = 45
        }
      },
      focusInput(fd) {
        if (this['digit_' + fd] != '' && parseInt(this['digit_' + fd]) > -1) {
          this.$refs['digit_' + (1 + parseInt(fd))].focus()
        } else {
          this['digit_' + fd] = null
        }
      },
      signUpSuccess(e, res) {
        this.loader = false
        if (e && e.file) {
          this.confirmUploadDial = true;
        } else if  (e && e.otp) {
          this.confirmUploadDial = false;
          this.confirmOtpDial = true;
        }
      },
      signUpFailure(e, res) {
        this.loader = false
        if (e && e.otp) {
          this.$store.dispatch('SET_ALERTMESSAGE', {msg: res.error, class: 'sa-a-danger'})
        } else if (e && e.file) {
          this.$store.dispatch('SET_ALERTMESSAGE', {msg: res.error, class: 'sa-a-danger'})
        }
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
        if (addRemoveClass === "addClass") {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
      reg(){
        this.$parent.showUploadView = false
        this.$parent.tabSelection = 'login'
      }
    },
    mounted() {
      this.toggleBodyClass('addClass', 'sa-signup');
    },
    destroyed() {
      // this.toggleBodyClass('removeClass', 'sa-signup');
    },
  };
</script>
